import type { SVGProps } from 'react';
import * as React from 'react';

const ArrowsRightLeftIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg width={24} height={24} viewBox="0 0 24 24" fill="none" aria-hidden="true" {...props}>
    <g id="outline/arrows-right-left">
      <path
        id="Icon"
        d="M7.5 12L3 16.5L7.5 21M3 16.5H16.5M16.5 12L21 7.5L16.5 3M21 7.5L7.5 7.5"
        stroke="currentColor"
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
  </svg>
);
export default ArrowsRightLeftIcon;
